/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取东艺演出场馆厅名称
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.DongYiVenueDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/theater/dongyi-hall`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
